import { NoSelectionProps } from "./NoSelection.types";

export const NoSelection = ({ className }: NoSelectionProps) => (
  <div className={`text-center py-8 ${className}`}>
    <div className="text-muted-foreground text-sm mb-2">No Project Selected</div>
    <div className="text-muted-foreground/70 text-xs">Select a project from the list</div>
  </div>
);
